import { render } from "./FormDatepicker.vue?vue&type=template&id=1b97a477"
import script from "./FormDatepicker.vue?vue&type=script&lang=ts"
export * from "./FormDatepicker.vue?vue&type=script&lang=ts"

import "./FormDatepicker.vue?vue&type=style&index=0&id=1b97a477&lang=scss"
script.render = render

export default script